import CreateViewModal from './CreateViewModal';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ListingLibCreateViewModal(props) {
  return /*#__PURE__*/_jsx(CreateViewModal, Object.assign({}, props, {
    formType: "CREATE_NEW"
  }));
}